import React, { useState } from "react";
import { TextField } from "@mui/material";
import styled from "styled-components";
import { BaseFlowStepEditor } from "../../Steps/BaseFlowStepEditor";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

const DescriptionText = styled(TextField)`
  .MuiOutlinedInput-root.Mui-focused {
    background: ${UIStyleConstants.BLUE_VERY_LIGHT_COLOR};

    .MuiOutlinedInput-notchedOutline {
      border-bottom: solid 1px ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    }
  }

  .MuiOutlinedInput-multiline {
    padding: 4px 12px 4px;
  }

  .MuiOutlinedInput-root {
    border-radius: 2px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;

    border-bottom: solid 1px transparent;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: transparent;
  }

  .MuiInputBase-root {
    color ${UIStyleConstants.GRAY_COLOR};;

    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 140%;
  }

  &.MuiFormControl-root {
    padding: 0 4px 8px;
  }
`;

export interface StepDescriptionProps {
    step: BaseFlowStepEditor;
    readOnly?: boolean;
}

export function StepDescription(props: StepDescriptionProps) {
    const [value, setValue] = useState<string>(props.step.description);
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    const updateStep = () => {
        props.step.description = value;
        props.step.stepUpdate();
    };

    return (
        <DescriptionText
            value={value}
            onChange={onChange}
            onBlur={() => updateStep()}
            multiline
            fullWidth
            variant="outlined"
            placeholder="Please type description"
            data-testid={`${props.step._id}_description`}
            classes={{
                root: "Step__description",
            }}
            InputProps={{
                readOnly: props.readOnly,
            }}
        />
    );
}
